import React from 'react';
import './style.scss';

function AssignmentRating() {
  return (
    <div className="tv-assignment-rating__container">
      <div className="tv-assignment-rating__text-grade">Betyg</div>
    </div>
  );
}

AssignmentRating.propTypes = {};

export default AssignmentRating;
